import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import PGHeaderNavItems from "./PGHeaderNavItems";
import PgHeroSection from "./PgHeroSection";
import LandingPageFooter from "../components/UG/Footer2";
import ExamExplore from "../components/ug_homepage/components/ExploreExam/ExamExplore";
import LearningCards from "./LearningCards";
import RestartCard from "./RestartCard";
import OurTeam from "./OurTeam";

const PgMainHomePage = () => {
  const location = useLocation();

  const heroRef = useRef(null);
  const examRef = useRef(null);
  const footerRef = useRef(null);

  const handleHomeClick = () => {
    heroRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

const handleExamsClick = () => {
  examRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
  const handleContactClick = () => {
    footerRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  useEffect(() => {
    if (!location.state?.scrollTo) return;

    const timer = setTimeout(() => {
      switch (location.state.scrollTo) {
        case "home":
          heroRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          break;

        case "exams":
        examRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
        break;

        case "footer":
          footerRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
          break;

        default:
          break;
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location]);

  return (
    <div className="Ug_Home_page_main_container">
      <PGHeaderNavItems
        onHomeClick={handleHomeClick}
        onExamsClick={handleExamsClick}
        onContactClick={handleContactClick}
      />

      <div ref={heroRef}>
        <PgHeroSection onExploreExams={handleExamsClick} />
      </div>

      <div className="exam-path-container" >
        <ExamExplore Sectionref={examRef}/>
      </div>
<RestartCard />
<LearningCards />
{/* <OurTeam /> */}

      <div ref={footerRef}>
        <LandingPageFooter />
      </div>
    </div>
  );
};

export default PgMainHomePage;